export default __webpack_public_path__ + "locales/bg/Settings.json?hash=2c185303de5810106e21364f2605107c";